<template>
    <div class="w100">
        <article class="wContent center" style="">
            <div class="swiper-container mw-modular-box" style="height: 300px;">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in videoSwiperList" :key="index" v-if="item.sortNul">
                        <a href="javascript:;" @click="goVideoDetail(item.viId)"><img :src="item.videoPicUrl" alt="" srcset="" style="width: 450px;"></a>
                    </div>
                </div>
                <!-- Add Pagination -->
                <!-- <div class="swiper-pagination"></div> -->
                <div class="swiper-button-next swiper-button-white"></div>
                <div class="swiper-button-prev swiper-button-white"></div>
            </div>

            <div class="mw-modular-box">
                <div class="i-v-types">
                    <span class="inlineBlock font14 textCenter pointer" v-for="(item, index) in videoType" :key="index" :class="{'active': videoTypeId == item.typeId}" @click="changeVideoType(item.typeId)">{{ item.typeName }}</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="6" v-for="(item, index) in videoList" :key="index">
                        <div class="i-v-list-sm " @click="goVideoDetail(item.viId)">
                            <img :src="item.videoPicUrl" class="w100" height="180px" alt="" srcset="">
                            <p class=" w100 font14">{{ item.title }}</p>
                        </div>
                    </el-col>
                </el-row>
                <!-- 分页 start -->
                <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;">
                    <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                </div>
                <!-- 分页 end -->
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import { baseUrl,adIDs } from '../../assets/js/common'
import $ from 'jquery'
import Swiper from 'swiper'
export default {
    name: 'VideoList',
    components: { ConcatsControl },
    data () {
        return {
            videoListTop: [],
            videoList: [],
            videoType: [],
            videoTypeId: '',
            videoSwiperList: [],
            pageNo: 1,
            pageSize: 12,
            totalnum: 0
        }
    },
    mounted () {
        // 初始化内容
        this.tVideoList();
        this.findAllVideoType();

    },
    methods: {
        //页面操作
        tVideoList () {
            const self = this;
            self.$post(`${baseUrl.online}/videoInfor/frontVideoList/1/99`, {videoTypeStatus: "Y"}).then(res => {
                if (res.code == 0) {
                    self.videoSwiperList = res.data ? res.data : [];
                    setTimeout(() => {
                        const swiper = new Swiper('.swiper-container', {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            centeredSlides: true,
                            loop: true,
                            // pagination: {
                            //     el: '.swiper-pagination',
                            //     clickable: true,
                            // },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                        });
                    }, 500)
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到快讯信息');
            })
        },

        findAllVideoType () {
            const self = this;
            self.$get(`${baseUrl.online}/videoType//findAllType?status=Y`, {}).then(res => {
                if (res.code == 0) {
                    self.videoType = res.data;
                    if (res.data.length > 0) {
                        self.videoTypeId = res.data[0]['typeId'];
                        self.getVideoListById(self.videoTypeId);
                    }
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到分类信息')
            })
        },
        getVideoListById (typeId) {
            const self = this;
            self.$post(`${baseUrl.online}/videoInfor/frontVideoList/${self.pageNo}/${self.pageSize}`, {typeId: typeId}).then(res => {
                if (res.code == 0) {
                    self.videoList = res.data;
                    self.totalnum = res.totalCount;
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到快讯信息');
            })
        },
        changeVideoType (typeId) {
            const _typeId = typeId;
            this.videoTypeId = _typeId;
            this.pageNo = 1;
            this.videoList = [];
            this.getVideoListById(_typeId);
        },
        goVideoDetail(typeId) {
            // this.$router.push(`/home/video?id=${typeId}`)
            let routeData = this.$router.resolve({ path: `/home/video?id=${typeId}`});
            window.open(routeData.href, '_blank');
        },
         // 切换分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.getVideoListById(this.videoTypeId);
        },

    },
}
</script>

<style scoped>
    .swiper-container {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
	  transition: 300ms;
	  transform: scale(0.8);
    }
	.swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
    }
    .swiper-button-next, .swiper-button-prev {
        width: 40px;
        height: 40px;
    }
    .i-v-types {
        margin-bottom: 20px;
        border-bottom: 1px solid #aaa;
    }
    .i-v-types span {
        line-height: 35px;
        margin: 0 10px;
        padding: 1px 30px 1px 0;
        border-radius: 5px;
        color: #333;
        font-size: 16px;
    }
    .i-v-types span.active {
        color: #a30000;
        font-weight: bold;
    }
    .i-v-list-sm {
        cursor: pointer;
    }
    .i-v-list-sm p {
        margin-top: 5px;
        line-height: 20px;
        height: 42px;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
</style>